import * as z from "zod";
import { attachmentSchema, dateSchema } from "./schemasComplex";
import { zRequiredString } from "./schemaUtils";

export const schemaFormAction = z.object({
  title: zRequiredString("Veuillez saisir un titre"),
  description: zRequiredString("Veuillez saisir une description"),
  dateAsked: dateSchema,
  date: dateSchema, // Required by the server, even if not displayed in the Figma
  causeType: z.enum(["CORRECTIF", "PREVENTIF"]),
  performer: zRequiredString("Veillez choisir un utilisateur"),
  effacity: z.string().optional(),
  event: z.string({
    // Hidden but present in fields values (via defaultValues)
    required_error: "Requis",
  }),
  attachedFiles: attachmentSchema,
});
